import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types';

interface NewsCardProps {
  item: NewsItem;
  showCover?: boolean;
}

export default function NewsCard({ item, showCover = true }: NewsCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:p-4"
    >
      {showCover && (
        <div className="h-24 w-32 shrink-0 overflow-hidden rounded-md bg-background-900 md:h-28 md:w-44">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} 资讯配图`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      )}
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-center gap-2 text-xs">
          <span className="rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-800">{item.category}</span>
          <span className="text-foreground-500">{item.date}</span>
        </div>
        <h3 className="mt-2 line-clamp-2 text-sm font-semibold text-foreground-950 group-hover:text-primary-600 md:text-base">
          {item.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 hidden text-xs leading-relaxed text-foreground-600 sm:block">
          {item.summary}
        </p>
      </div>
    </Link>
  );
}